import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'or-row-skeleton',
  template: ``,
  styleUrls: ['./row-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'or-skeleton-animated' },
  standalone: false
})
export class RowSkeletonComponent {}
